import { OrderModel } from "../../../shared/models/order/order-item.model";
import React, { useEffect, useState } from "react";
import { AdditionalServiceUsage } from "../../../components/additional-service";
import { AdditionalServiceModel } from "../../../shared/models/order/additional-service.model";
import { AdditionalServiceDialog } from "./additional-service-dialog/additional-service-dialog";
import { AdditionalServiceOrderPopupContainer } from "./styled";

const SingleAdditionalService = ({
  order,
  service,
  usage,
  selected,
  onSelect,
  isNewOrder,
  isReadonly,
  updateData,
}: AdditionalServicesProps) => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [additionalServiceData, setAdditionalServiceData] = useState<{
    [key: string]: any;
  }>({});

  useEffect(() => {
    if (service.additionalServiceId === 6) {
      setAdditionalServiceData({
        isOnHold: order.additionalService.some(
          (service) => service.additionalServiceId === 6,
        ),
      });
    }
  }, [order]);

  function changeOrderOnHold(isOnHold: boolean) {
    setAdditionalServiceData({ isOnHold });
    setDialogOpen(true);
  }

  const getServiceCard = (service: AdditionalServiceModel) => {
    switch (service.additionalServiceId) {
      case 1: // check_the_package_contents
        return <></>;
      case 2: // additional_packaging
        return <></>;
      case 3: // change_receiver
        return <></>;
      case 4: // divide_package
        return <></>;
      case 5: // home_delivery
        return <></>;
      case 6: // on_hold
      // return <AdditionalServiceCard usage={usage}
      //                               secondaryIcon={<Switch disabled={isReadonly}
      //                               checked={updateData && updateData.additionalService
      //                                   ? updateData.additionalService?.some((service: AdditionalServiceModel) => service.additionalServiceId === 6)
      //                                   : order.additionalService?.some(service => service.additionalServiceId === 6)}
      //                               onChange={(event) => changeOrderOnHold(event.target.checked)}/>}
      //                               selected={selected}
      //                               slim={true}
      //                               mainMessage={sectionMessages.keep_on_hold ? sectionMessages.keep_on_hold.name : 'keep_on_hold'}
      //                               order={order}
      //                               onClick={() => true}/>
      default:
        return <></>;
    }
  };

  function handleDialogClosed(confirmed: boolean, existingOrderUpdates?: any) {
    if (confirmed && order.orderId) {
      switch (service.additionalServiceId) {
        case 1: // check_the_package_contents
        case 2: // additional_packaging
        case 3: // change_receiver
        case 4: // divide_package
        case 5: // home_delivery
        case 6: // on_hold
      }

      onSelect(existingOrderUpdates);
    }

    setDialogOpen(false);
  }

  if (additionalServiceData) {
    return (
      <AdditionalServiceOrderPopupContainer item>
        <AdditionalServiceDialog
          open={dialogOpen}
          order={order}
          updateData={updateData}
          service={service}
          isNewOrder={isNewOrder}
          additionalServiceData={additionalServiceData}
          handleClose={handleDialogClosed}
        />

        {getServiceCard(service)}
      </AdditionalServiceOrderPopupContainer>
    );
  } else {
    return <></>;
  }
};

export default SingleAdditionalService;

interface AdditionalServicesProps {
  service: AdditionalServiceModel;
  order: OrderModel;
  selected: boolean;
  onSelect: (updateData: { [key: string]: any }) => void;
  updateData?: { [key: string]: any };
  usage: AdditionalServiceUsage;
  isNewOrder: boolean;
  isReadonly?: boolean;
}
